import Image from "next/image";
import Link from "next/link";
import { useRouter } from 'next/router'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { Scrollbar } from "swiper";
import { Autoplay } from "swiper";
import { Controller } from "swiper";
import StarIcon from "@mui/icons-material/Star";
import Rating from '@mui/material/Rating';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRelatedProducts } from "../../redux/slices/common";
import { Skeleton } from "@mui/material";

const PopularDestinations = ({ serviceType, type }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const [services, setServices] = useState([]);
  const { getRelatedProductsRes } = useSelector((state) => state.common);
  const { _id } = router.query;

  useEffect(() => {
    if (!serviceType || !type) return;

    const obj = {
      serviceType: Number(serviceType),
      type,
      _id: _id
    };

    dispatch(getRelatedProducts(obj));
  }, [dispatch, serviceType, type]);

  useEffect(() => {
    if (getRelatedProductsRes && getRelatedProductsRes !== undefined) {
      setServices(getRelatedProductsRes?.responseData);
    }
  }, [getRelatedProductsRes]);

  const [secondSwiper, setSecondSwiper] = useState(null);

  return (
    <>
      <section
        className="section-bg layout-pb-md md:pt-40 md:pb-40 "
        data-aos="fade-up">
        <Swiper
          onSwiper={setSecondSwiper}
          controller={{ control: secondSwiper }}
          spaceBetween={20}
          className="overflow-visible"
          scrollbar={{
            el: ".js-popular-destination-scrollbar",
            draggable: true,
          }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Controller, Autoplay, Scrollbar, Navigation]}
          navigation={{
            nextEl: ".js-second-destination-next",
            prevEl: ".js-second-destination-prev",
          }}
          breakpoints={{
            300: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          }}
        >
          {services?.length === 0 ? (
            <div className="d-flex flex-row">
              {[1, 2, 3].map((index) => (
                <div className="p-3 rounded mb-3" key={index}>
                  <div className="car-main__section">
                    <div className="car-main__section_in">
                      <div className="car-main__image">
                        <Skeleton
                          animation="wave"
                          variant="rectangular"
                          width={340}
                          height={340}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            services?.map((item) => {
              const typePaths = {
                4: '/staycation/staycation-details',
                6: '/activities/activity-details',
                7: '/busrental/bus-details',
                8: '/holidaypackage/holiday-details',
                9: '/carrentalnew/car-details'
              };

              const getTypePath = (type) => {
                return typePaths[type] || '';
              };

              return (
                <SwiperSlide key={item.id} onClick={() => {
                  const url = `${getTypePath(item.type)}?_id=${item?._id}`;
                  window.open(url, "_blank"); // Opens in a new tab
                }} 
                style={{ cursor: "pointer" }} >
                  <div
                    className="citiesCard -type-1 d-block card-border"
                  >
                    <div className="citiesCard__image ratio ratio-1:1">
                      <Image
                        width={300}
                        height={300}
                        // src={item?.img}
                        src={`${process.env.IMAGE_BASE_URL}/${item?.image}`}
                        alt="image"
                        className="js-lazy rounded-4"
                      />
                    </div>

                    {/* New Desc */}

                    <div className="citiesCard__content py-5 px-1">
                      <div className="d-flex align-center justify-between">
                        <div className="card-sub-title">{item.name}</div>
                        <div className="d-flex align-center gap-2 nowrap">
                          <Rating name="half-rating-read" className="card-rating" defaultValue={item?.rating} precision={0.5} readOnly size="small" />
                          {/* <StarIcon fontSize="small" style={{ color: "gold" }} />{" "} */}
                          {item?.reviews && item?.reviews !== null && item?.reviews > 0 && (
                            <span className="card-rating">
                              {`(${item?.reviews})`}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })
          )}
        </Swiper>

        <div className="z-5">
          <button className="section-slider-nav z-5 -prev flex-center button -dark-3 bg-white shadow-1 size-40 rounded-full sm:d-none js-second-destination-prev">
            <i className="icon icon-chevron-left text-12" />
          </button>
          <button className="section-slider-nav z-5 -next flex-center button -dark-3 bg-white shadow-1 size-40 rounded-full sm:d-none js-second-destination-next">
            <i className="icon icon-chevron-right text-12" />
          </button>
        </div>

      </section>
    </>
  );
};

export default PopularDestinations;
